export enum BackofficeUserRoles {
  ADMIN = 1,
  INSPECTOR,
  REPORT_USER
}
